module.exports = __webpack_public_path__ + "img/cat-jachet.f3145be2.png";